import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"

const LazyImage = (props) => {
  const {
    src,
    imageWidth,
    quality = 100,
    ...otherProps
  } = props

  const source = src === "/" ? "" : src

  return (
    <LazyLoadImage
      src={source
        ?
        imageWidth
          ? `${source}?width=${imageWidth}&quality=${quality}`
          : source
        : "/assets/images/default-image.jpg"
      }
      {...otherProps}
    />
  )
}

export default LazyImage